/* ⚠️ Charl, 20 Oct 2026: "often there's a zero in there, and you can't delete the zero ... I wanted to put in 35, but then
   it makes it 350 ... as soon as you click on the box, that zero needs to disappear, and you need to be able to put in your
   own value there."
   Every number box in FlashPro: tapping or clicking into it SELECTS what is in it, so the first key typed replaces it -
   a 0 (or any old number) can never be typed in front of or behind. Nothing is changed until something is typed, so a box
   that is only looked at keeps its value. One listener for the whole app, so no box can be missed. */
export function selectOnFocus(doc) {
  if (!doc || doc.__ffNumFocus) return;
  doc.__ffNumFocus = true;
  const isNum = t => !!t && t.tagName === "INPUT" && (t.type === "number" || t.inputMode === "numeric" || t.inputMode === "decimal");
  let fresh = null;
  const sel = t => { try { t.select(); } catch (e) {} };
  doc.addEventListener("focusin", e => {
    const t = e.target; if (!isNum(t)) return;
    fresh = t; sel(t);
    setTimeout(() => { if (doc.activeElement === t && fresh === t) sel(t); }, 0);   // iPad / Safari place the caret after focus
  }, true);
  /* the click that focused the box can drop the selection again (Safari) - select once more just after it.
     ⚠️ Charl, 21 Oct: "if you click on the little arrow now, it just runs". This used to BLOCK that mouse release, so the
     box's own up/down arrows never heard the button let go and kept counting (3 -> 30). The release is never blocked now;
     and if the click changed the number (it was on an arrow), it is left exactly as the arrow made it. */
  doc.addEventListener("mouseup", e => {
    const t = fresh; if (!t || e.target !== t) return; fresh = null;
    const was = t.value;
    setTimeout(() => { if (doc.activeElement === t && t.value === was) sel(t); }, 0);
  }, true);
  doc.addEventListener("keydown", e => { if (fresh && e.target === fresh) fresh = null; }, true);
  doc.addEventListener("focusout", e => { if (fresh === e.target) fresh = null; }, true);
}
